import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSales } from 'app/mocks/data/transactions/sales'

import { api } from 'app/utils/constants'

import { Sale } from 'app/types/transactions/sale'

export const getSale = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.transactions.sales.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const saleFound = allSales.find((sale) => sale.id.toString() === id)

        // Not found
        if (!saleFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Sale>(saleFound)
    },
)
